import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import classNames from 'classnames';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export interface Props extends ImageProps {
  lazy?: boolean,
}

export const Image: React.FC<Props> = ({
  className,
  src,
  lazy,
  alt,
  ...props
}) => (
  <img
    {...props}
    className={classNames(className, {
      lazyload: lazy,
    })}
    src={lazy ? undefined : src}
    data-src={lazy ? src : undefined}
    alt={alt}
  />
);
